import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { publicEventStyle, safeAssetUrl } from "../../lib/personalization";
import { useConfig } from "../../lib/useConfig";
import { useEventPersonalization } from "../../lib/useEventPersonalization";
import { BrandMark } from "./BrandMark";

export function PublicShell() {
  const config = useConfig({ optional: true });
  const location = useLocation();
  const isRootLanding = location.pathname === "/";
  const pathSlugs = location.pathname.match(/^\/(?:upload|gallery|memory-media-vault|memory-hub)\/([^/]+)\/([^/]+)/);
  const clientSlug = isRootLanding ? undefined : pathSlugs?.[1] || config?.clientSlug;
  const eventSlug = isRootLanding ? undefined : pathSlugs?.[2] || config?.eventSlug;
  const eventDetails = useEventPersonalization(clientSlug, eventSlug);
  const logo = isRootLanding ? "" : safeAssetUrl(eventDetails?.optionalLogo);
  const headerTitle = isRootLanding ? "Kreatethedate" : eventDetails?.eventName || "Memory Media Vault";
  const onVault = location.pathname.startsWith("/memory-media-vault/");
  const vaultPath = !isRootLanding && clientSlug && eventSlug ? `/memory-media-vault/${clientSlug}/${eventSlug}` : "/";
  const navItems = [
    ...(!isRootLanding && clientSlug && eventSlug
      ? [
          {
            label: onVault ? "Memory Media Vault" : "Back to Vault",
            to: vaultPath,
          },
          { label: "Upload", to: `/upload/${clientSlug}/${eventSlug}` },
          { label: "Gallery", to: `/gallery/${clientSlug}/${eventSlug}` },
        ]
      : []),
  ];

  return (
    <div className="event-public-shell min-h-screen text-white" style={publicEventStyle(isRootLanding ? null : eventDetails)}>
      <header className="sticky top-0 z-40 border-b border-ktd-gold/15 bg-ktd-black/90 px-4 py-4 backdrop-blur-xl sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
          {isRootLanding ? (
            <BrandMark />
          ) : (
            <Link to={vaultPath} className="focus-ring inline-flex items-center gap-3 rounded-lg">
              {logo ? (
                <img src={logo} alt={`${eventDetails?.clientName || "Client"} logo`} className="size-11 rounded-lg object-contain" />
              ) : (
                <span className="grid size-11 place-items-center rounded-lg border border-white/15 bg-white/[0.08] text-lg font-black">
                  {headerTitle.charAt(0)}
                </span>
              )}
              <span className="leading-tight">
                <span className="block font-display text-lg font-bold text-white">{headerTitle}</span>
                <span className="block text-xs font-semibold uppercase tracking-[0.18em]" style={{ color: "var(--event-accent)" }}>
                  Memory Media Vault
                </span>
              </span>
            </Link>
          )}
          <nav className="luxury-scrollbar flex w-full items-center gap-2 overflow-x-auto pb-1 sm:w-auto sm:pb-0" aria-label="Public navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `focus-ring rounded-lg px-4 py-2 text-sm font-semibold transition ${
                    isActive ? "event-button" : "text-white/76 hover:bg-white/10 hover:text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <Outlet />
      <footer className="border-t border-ktd-gold/20 px-4 py-10 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-[1.2fr_.8fr]">
          <div>
            <p className="mt-5 max-w-2xl text-sm leading-7 text-white/68">
              Event memories are uploaded, reviewed, and shared in the Memory Media Vault once approved.
            </p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] text-white/38">
              Powered by Kreatethedate Memory Media Vault
            </p>
            <Link to="/login" className="focus-ring mt-5 inline-flex text-xs font-bold uppercase tracking-[0.18em] text-white/50 hover:text-white">
              Client Access
            </Link>
          </div>
          <div className="vault-rail rounded-lg border border-ktd-gold/20 bg-white/[0.04] p-5 text-sm leading-7 text-white/66">
            Cloudflare billing is managed directly through each client-owned Cloudflare account. Kreatethedate provides
            setup, design, connection, and support while services are active.
          </div>
        </div>
      </footer>
    </div>
  );
}
